<template>
    <section class="section">
        <div class="hero">
            <div class="hero-head has-text-centered">
                <h1 class="title is-1 is-hidden-mobile">{{edar.name}}</h1>
                <h1 class="title is-1 is-hidden-tablet full-width-inside-section"
                    :class="{
                        'has-background-warning': edar.status === 'Faulted',
                        'has-background-danger': edar.status === 'Offline',
                        'has-text-white': edar.status !== 'Online',
                        }"
                >{{edar.name}}</h1>
            </div>
        </div>
        <br class="is-hidden-tablet">
        <div v-if="edar.last_status_message" class="container" :class="{'box': isDesktop}">
            <h3 class="title is-3 is-hidden-mobile">
                Current Status: <span class="has-underline" :class="{
                    'has-underline-warning': edar.status === 'Faulted',
                    'has-underline-danger': edar.status === 'Offline',
                    }">{{ edar.status }}</span>
            </h3>
            <h3 class="title is-3">
<!--                See here: https://stackoverflow.com/questions/5392853/html-css-denoting-a-preferred-place-for-a-line-break-->
                <span class="is-inline-block">Last Seen: </span>
                <span class="is-hidden-mobile">
                    <span class="is-inline-block">{{ edar.last_seen.format('MMMM Do YYYY, hh:mm a') }}</span>
                    -
                    <span class="is-inline-block">{{ edar.last_seen.fromNow() }}</span>
                </span>
                <span class="is-hidden-tablet">
                    {{ edar.last_seen.fromNow() }}
                </span>
            </h3>
            <hr>
            <div>
            <h3 class="title is-3" style="margin-bottom: 0.2em;">Annunciators:</h3>
            <span v-if="edar.last_status_message.annunciators.length">Click for details</span>
            <span v-else>The EDAR did not send any annunciators<br></span>
            <div class="is-inline-flex is-inline-block" style="flex-wrap: wrap;">
                <div v-for="(annunciator, index) in edar.last_status_message.annunciators" v-bind:key="annunciator.title + index"
                     class="button annunciator-element" :class="{'has-background-danger': annunciator.active, 'has-text-white': annunciator.active}"
                     :title="annunciator.message"
                     @click="showAnnunciatorDetail = !showAnnunciatorDetail"
                >
                    {{ annunciator.title }}
                </div>
            </div>
            <div v-if="showAnnunciatorDetail">
                <table class="table is-hidden-mobile">
                    <thead><tr>
                        <th>Active</th>
                        <th>Name</th>
                        <th>Message</th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="(annunciator, index) in edar.last_status_message.activeAnnunciators" v-bind:key="annunciator.title + index"
                            class="has-background-danger has-text-white">
                            <td><i class="fas fa-check-circle"></i></td>
                            <td>{{annunciator.title}}</td>
                            <td><div class="annunciator-message">{{ annunciator.message }}</div></td>
                        </tr>
                        <tr v-for="(annunciator, index) in edar.last_status_message.inactiveAnnunciators" v-bind:key="annunciator.title + index">
                            <td></td>
                            <td>{{annunciator.title}}</td>
                            <td><div class="annunciator-message">{{ annunciator.message }}</div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
            <hr>
            <div>
                <h3 class="title is-3">Information:</h3>
                <table class="table">
                    <thead><tr>
                        <th>Name</th>
                        <th>Details</th>
                    </tr></thead>
                    <tbody>
                        <tr v-for="(info, index) in edar.infos"  v-bind:key="info.name + index"
                            :title="info.about"
                        >
                            <td>{{info.name}}</td>
                            <td>{{info.details}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="$store.state.debug">
                <hr>
                <h3 class="title is-2">Debug only items:</h3>
                <p>
                    These are items which are useful, but may be misinterpreted.
                    A Key point made multiple times is that the Status Monitor is <b>NOT</b> a source of truth.
                    EDAR makes zero guarantees about if the data it sends is correct or that the data will even arrive.
                </p>
                <hr>
                <h3 class="title is-3">Fault History (last day):</h3>
                <div>
                    <edar-history :height="100" :edar="this.edar"></edar-history>
                </div>
            </div>
        </div>
        <div v-else class="container">
            <h3 class="title is-3">EDAR has never been seen online!  Does it really exist?</h3>
        </div>
    </section>
</template>

<script>
    import {isSize} from "../../../mixins";
    // import EdarHistory from "../../../components/Info/EdarHistory";
    const EdarHistory = () => import("../../../components/Info/EdarHistory");

    export default {
        name: "Detail",
        components: {EdarHistory},
        mixins: [isSize],
        props: {
            edarId: {
                type: [String, Number],
                required: true,
            },
        },
        data: () => ({
            "showAnnunciatorDetail": false,
        }),
        computed: {
            //Pull the specific EDAR we're interested in out of the store
            edar() {
                return this.$store.getters['edar/byId'](this.edarId);
            },
        },
        beforeRouteEnter(to, from, next){
            let edar = window.app.$store.getters['edar/byId'](to.params.edarId);
            to.meta.breadcrumb = `${edar} Details`;
            next();
        },
        beforeRouteUpdate(to, from, next){
            let edar = this.$store.getters['edar/byId'](to.params.edarId);
            to.meta.breadcrumb = `${edar} Details`;
            next();
        },
    }
</script>

<style scoped lang="scss">
    .annunciator-message {
        white-space: pre-wrap;
    }

</style>